export const importTaskStates = {
  analysis: 'Analyse en cours', review: 'À vérifier', correction: 'À corriger',
  paused: 'En pause', ready: 'Prêt à importer', partial: 'Import partiel',
  importing: 'Import en cours', completed: 'Terminé',
};

export const taskDate = (value) => value ? new Date(value).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' }) : '—';

export const editableTaskFields = ['title', 'reference', 'planId', 'folderId', 'archiveProfileId', 'regleConservationId', 'producerServiceId', 'metadataJson'];

export const rowsWithDraft = (rows, patches = {}) => rows.map((row) => {
  const patch = patches[row.file];
  if (!patch || row.imported) return row;
  const next = { ...row, ...patch };
  if (Object.prototype.hasOwnProperty.call(patch, 'metadataJson')) {
    try {
      const parsed = JSON.parse(patch.metadataJson);
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) throw new Error('object');
      next.metadata = parsed; next.metadataError = '';
    } catch (_) { next.metadataError = 'JSON invalide'; }
  }
  if (patch.metadataJson !== undefined || patch.archiveProfileId !== undefined) {
    next.reviewed = false; next.reviewStatus = 'pending';
  }
  return next;
});

export const taskRowPatches = (items, sourceRows = []) => {
  const source = new Map(sourceRows.map((row) => [row.file, row]));
  const patches = {};
  items.forEach((item) => {
    const base = source.get(item.file);
    if (!base || base.imported) return;
    editableTaskFields.forEach((key) => {
      const original = key === 'metadataJson' ? JSON.stringify(base.metadata && !Array.isArray(base.metadata) ? base.metadata : {}) : String(base[key] ?? '');
      const value = String(item[key] ?? '');
      if (value !== original) patches[item.file] = { ...patches[item.file], [key]: value };
    });
  });
  return patches;
};
